import { globalStyle, style } from "@vanilla-extract/css";
import { kHostBottomInset } from "@/client/utils/hostInset";
import { pct, px } from "@/client/utils/units";
import { colors } from "./colors.css";
import { fontFamily } from "./typography.css";

globalStyle("body", {
    backgroundColor: colors.gray90,
    color: "white",
    fontFamily,
    padding: "0",
    margin: "0",
    minWidth: "100%",
    minHeight: "100vh",
    boxSizing: "border-box",
});

// App pages scroll the document, so the host's floating-UI clearance (the
// Sounds plugin playbar pill) extends the body's scrollable extent.
globalStyle("body", {
    paddingBottom: kHostBottomInset,
});

globalStyle("button", {
    cursor: "pointer",
});

// Matches the Creative Partner panels' design-system scrollbar (the
// `style-scrollbar` mixin): 16px track, 4px transparent inset around an 8px
// thumb, dark-theme thumb colors — so the embedded Labs panel scrolls
// identically to the catalog and tools panes beside it.
const scrollbarWidth_px = 16;
const scrollbarInset_px = 4;

globalStyle("::-webkit-scrollbar", {
    appearance: "none",
    width: px(scrollbarWidth_px),
    height: px(scrollbarWidth_px),
});

globalStyle("::-webkit-scrollbar-track", {
    background: "transparent",
});

globalStyle("::-webkit-scrollbar-thumb", {
    backgroundColor: colors.gray60,
    borderRadius: px(8),
    borderWidth: px(scrollbarInset_px),
    borderStyle: "solid",
    borderColor: "transparent",
    backgroundClip: "padding-box",
});

globalStyle("::-webkit-scrollbar-thumb:hover", {
    backgroundColor: colors.gray50,
});

export const view = style({
    width: pct(100),
    height: pct(100),
});
